// extracted by mini-css-extract-plugin
module.exports = {"headerSize":"Header_headerSize__g4BVS"};